/*
  Allure Studios — Product Page JS
  Variant selection without reload, gallery + desktop zoom, size guide modal,
  sticky mobile Add to Bag bar, recently viewed (localStorage), and
  async product recommendations.
*/
(function () {
  "use strict";
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------
     Variant Picker
  ------------------------------------------------------------ */
  function initVariantPicker(root) {
    var dataEl = qs("[data-product-json]", root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = qs('input[name="id"]', root);
    var priceEl = qs("[data-product-price]", root);
    var comparePriceEl = qs("[data-product-compare-price]", root);
    var atcBtn = qs("[data-add-to-bag]", root);
    var inventoryEl = qs("[data-inventory-message]", root);
    var skuEl = qs("[data-product-sku]", root);
    var stickyTitle = qs("[data-sticky-atc-title]");
    var stickyPrice = qs("[data-sticky-atc-price]");

    var selected = {};
    qsa("[data-option-index]", root).forEach(function (input) {
      if (input.checked || input.classList.contains("is-selected")) {
        selected[input.getAttribute("data-option-index")] = input.getAttribute("data-value");
      }
    });
    // Fallback to first available combination if nothing pre-selected
    if (Object.keys(selected).length === 0 && product.options) {
      product.options.forEach(function (name, idx) { selected[idx] = product.variants[0]["option" + (idx + 1)]; });
    }

    function findVariant() {
      return product.variants.find(function (v) {
        return product.options.every(function (name, idx) {
          return String(v["option" + (idx + 1)]) === String(selected[idx]);
        });
      });
    }

    function render() {
      var variant = findVariant();
      if (!variant) return;

      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = window.Allure.formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = window.Allure.formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
          if (priceEl) priceEl.classList.add("price--sale");
        } else {
          comparePriceEl.hidden = true;
          if (priceEl) priceEl.classList.remove("price--sale");
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? atcBtn.getAttribute("data-label-available") : atcBtn.getAttribute("data-label-sold-out");
      }
      if (inventoryEl) {
        if (!variant.available) {
          inventoryEl.textContent = "Sold out";
          inventoryEl.className = "inventory-message";
        } else if (variant.inventory_management === "shopify" && typeof variant.inventory_quantity === "number" && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          inventoryEl.textContent = "Only " + variant.inventory_quantity + " left";
          inventoryEl.className = "inventory-message inventory-message--low";
        } else {
          inventoryEl.textContent = "In stock, ready to ship";
          inventoryEl.className = "inventory-message inventory-message--in-stock";
        }
      }
      if (skuEl) skuEl.textContent = variant.sku || "";

      // Swap gallery to the variant's featured image (if a matching image exists)
      if (variant.featured_image) {
        // There are two matching slides in the DOM (desktop stack + mobile swipe track);
        // only scroll whichever one is actually visible at the current viewport width.
        var matchingSlides = qsa('[data-gallery-slide][data-image-id="' + variant.featured_image.id + '"]', root);
        matchingSlides.forEach(function (slide) {
          if (slide.offsetParent !== null) {
            slide.scrollIntoView({ behavior: "instant", inline: "start", block: "nearest" });
          }
        });
      }

      // Update option button disabled state (only for two-level swatch+size UIs)
      qsa("[data-option-index]", root).forEach(function (input) {
        var idx = input.getAttribute("data-option-index");
        var value = input.getAttribute("data-value");
        var isSelected = String(selected[idx]) === String(value);
        input.classList.toggle("is-selected", isSelected);
        if (input.type === "radio") input.checked = isSelected;
      });

      // Update the "Size: M" / "Color: Black" label text next to each option group
      qsa("[data-option-group]", root).forEach(function (group) {
        var idx = group.getAttribute("data-option-group");
        var label = qs("[data-selected-value]", group);
        if (label && selected[idx] !== undefined) label.textContent = selected[idx];
      });

      // Update URL (shallow) for shareable variant links
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      }

      if (stickyTitle) stickyTitle.textContent = product.title;
      if (stickyPrice) stickyPrice.textContent = window.Allure.formatMoney(variant.price);

      document.dispatchEvent(new CustomEvent("variant:change", { detail: variant }));
    }

    root.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-option-index].size-option, [data-option-index].swatch");
      if (!opt) return;
      selected[opt.getAttribute("data-option-index")] = opt.getAttribute("data-value");
      render();
    });
    root.addEventListener("change", function (e) {
      var opt = e.target.closest('[data-option-index][type="radio"]');
      if (!opt) return;
      selected[opt.getAttribute("data-option-index")] = opt.getAttribute("data-value");
      render();
    });

    render();
  }

  /* ---------------------------------------------------------
     Quantity selector (shared markup, PDP scope)
  ------------------------------------------------------------ */
  function initQuantitySelectors(root) {
    qsa("[data-qty-selector]", root).forEach(function (wrap) {
      var input = qs("[data-qty-input]", wrap);
      qs("[data-qty-decrease]", wrap).addEventListener("click", function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      qs("[data-qty-increase]", wrap).addEventListener("click", function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------------------------------------------------------
     Gallery: mobile swipe dots + desktop zoom overlay
  ------------------------------------------------------------ */
  function initGallery(root) {
    var mobileTrack = qs("[data-gallery-mobile]", root);
    var dots = qsa("[data-gallery-dot]", root);
    if (mobileTrack && dots.length) {
      mobileTrack.addEventListener(
        "scroll",
        function () {
          var index = Math.round(mobileTrack.scrollLeft / mobileTrack.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle("is-active", i === index); });
        },
        { passive: true }
      );
    }

    var zoomLayer = qs("[data-gallery-zoom-layer]", root);
    if (zoomLayer) {
      qsa("[data-gallery-slide] img", root).forEach(function (img) {
        img.addEventListener("click", function () {
          if (window.matchMedia("(min-width: 990px)").matches) {
            qs("img", zoomLayer).src = img.getAttribute("data-zoom-src") || img.src;
            zoomLayer.classList.add("is-open");
          }
        });
      });
      zoomLayer.addEventListener("click", function () { zoomLayer.classList.remove("is-open"); });
    }
  }

  /* ---------------------------------------------------------
     Size guide modal
  ------------------------------------------------------------ */
  function initSizeGuide(root) {
    var modal = qs("[data-size-guide-modal]");
    if (!modal) return;
    qsa("[data-size-guide-open]", root).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        modal.classList.add("is-open");
        document.documentElement.style.overflow = "hidden";
      });
    });
    modal.addEventListener("click", function (e) {
      if (e.target.closest("[data-size-guide-close]") || e.target.classList.contains("size-guide-modal__overlay")) {
        modal.classList.remove("is-open");
        document.documentElement.style.overflow = "";
      }
    });
  }

  /* ---------------------------------------------------------
     Sticky mobile Add to Bag bar
  ------------------------------------------------------------ */
  function initStickyAtc(root) {
    var bar = qs("[data-sticky-atc]");
    var buyBox = qs("[data-product-buy-box]", root);
    if (!bar || !buyBox || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(buyBox);

    qs("[data-sticky-atc-submit]", bar) &&
      qs("[data-sticky-atc-submit]", bar).addEventListener("click", function () {
        var form = qs('form[data-product-form]', root);
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true }));
      });
  }

  /* ---------------------------------------------------------
     Recently viewed (localStorage)
  ------------------------------------------------------------ */
  var RecentlyViewed = {
    key: "allure_recently_viewed",
    track: function (handle) {
      try {
        var list = JSON.parse(localStorage.getItem(this.key)) || [];
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem(this.key, JSON.stringify(list.slice(0, 12)));
      } catch (e) {}
    },
    render: function () {
      var section = qs("[data-recently-viewed]");
      if (!section) return;
      var currentHandle = section.getAttribute("data-current-handle");
      var list;
      try { list = JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { list = []; }
      list = list.filter(function (h) { return h !== currentHandle; }).slice(0, 4);
      if (!list.length) { section.hidden = true; return; }

      Promise.all(
        list.map(function (handle) {
          return fetch("/products/" + handle + ".js").then(function (r) { return (r.ok ? r.json() : null); }).catch(function () { return null; });
        })
      ).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) { section.hidden = true; return; }
        var grid = qs("[data-recently-viewed-grid]", section);
        grid.innerHTML = products
          .map(function (p) {
            var img = p.featured_image || (p.images && p.images[0]) || "";
            return (
              '<a class="product-card" href="' + p.url + '">' +
                '<div class="product-card__media"><img class="product-card__image--front" src="' + img + '" alt="' + p.title + '" loading="lazy"></div>' +
                '<div class="product-card__info"><p class="product-card__title">' + p.title + '</p>' +
                '<p class="product-card__price">' + window.Allure.formatMoney(p.price) + "</p></div>" +
              "</a>"
            );
          })
          .join("");
        section.hidden = false;
      });
    },
  };

  /* ---------------------------------------------------------
     Product recommendations (native Shopify recommendation API)
  ------------------------------------------------------------ */
  function initRecommendations() {
    var el = qs("[data-product-recommendations]");
    if (!el) return;
    var url = el.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var inner = doc.querySelector("[data-product-recommendations-inner]");
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
        } else {
          el.hidden = true;
        }
      })
      .catch(function () { el.hidden = true; });
  }

  function initShare(root) {
    var btn = qs("[data-native-share]", root);
    if (!btn) return;
    btn.addEventListener("click", function () {
      var title = btn.getAttribute("data-native-share");
      var url = btn.getAttribute("data-share-url");
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var original = btn.innerHTML;
          btn.innerHTML = "Link copied";
          setTimeout(function () { btn.innerHTML = original; }, 1800);
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = qs("[data-product-root]");
    if (!root) return;
    initVariantPicker(root);
    initQuantitySelectors(root);
    initGallery(root);
    initSizeGuide(root);
    initStickyAtc(root);
    initShare(root);
    RecentlyViewed.track(root.getAttribute("data-product-handle"));
    RecentlyViewed.render();
    initRecommendations();
  });
})();
